import {default as _} from 'lodash';
import { Component, OnInit, ViewChild } from '@angular/core';
import { default as GridColumnsJSON } from './user-action-log-gridColumns.json';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { GridService } from 'app/Shared/Services/grid.service';
import { HttpErrorResponse } from '@angular/common/http';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { UserActionLog } from './user-action-log.model';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { DataService } from 'app/Shared/Services/data.service';
import { JsonViewerService } from "app/Shared/Component/json-viewer/json-viewer.service";
import { SortPipe } from 'app/Shared/Component/pipes/sort.pipe';
import { Table, TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { saveAs } from 'file-saver';
import { ExportToCSVSComponent } from 'app/Shared/Component/export-to-csv/export-to-csv.component';
import { asBlob, generateCsv } from 'export-to-csv';
import { FormatterComponent} from 'app/Shared/Component/json-viewer/json-formatter.component'
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import {MatTabsModule} from '@angular/material/tabs';
import { PrettyJsonPipe } from 'app/Shared/Component/pipes/prettyjson.pipe';
import { LowerCasePipe, NgClass, CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DrawerModule } from 'primeng/drawer';


@Component({
    selector: 'app-user-action-log',
    templateUrl: './user-action-log.component.html',
    styleUrls: ['./user-action-log.component.scss'],
    imports: [TableModule, ToastModule, ExportToCSVSComponent, FilterPanelComponent, FormatterComponent, MatProgressSpinner, MatTabsModule, PrettyJsonPipe,
        CommonModule, NgClass, DrawerModule, ButtonModule, MatTooltipModule, LowerCasePipe
    ]
})
export class UserActionLogComponent implements OnInit {
  @ViewChild(('dt')) dt!: Table;
  GridColumns = GridColumnsJSON;
  dataset: UserActionLog[] = [];
  selectedRow: UserActionLog = new UserActionLog();
  isLoadingResults: boolean = true;
  tbldatamsg: string = "L o a d i n g . . . . .";
  totalRecords!: number;
  Limit: any = { 'Start': '', 'End': '' };
  previousLimit: any = { 'Start': '', 'End': '' };
  defaultFilterArray: any = [];
  startLimit: any = 0;
  endLimit!: number;
  rowcount!: number;
  columnJson: any = [];
  cols: any = [];
  priviousStartLimit: any;
  pageNumber: any = 1;
  sortData:any = { field: '', order: 0};
  sortClickCounter: number = 0;
  LastExecutionDate: any = '';
  orderDateRange: any = '';
  routeDateRange: any = '';
  isDataViewer: boolean = false;
  hasJsonParameters: boolean = false;
  activity: any = '';
  activityDetail: any = '';

  constructor(public constantService: ConstantService,
    public dataService: DataService,
    public jsonViewerService: JsonViewerService,
    private gridService: GridService,
    private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService,
    private messageService: MessageService,
    private emitterService: EmitterService,
    private userService: UserService,
    private sortPipe: SortPipe) {
  }

  ngOnInit() {
      this.rowcount = this.constantService.DEFAULT_ROWSIZE;
      this.endLimit = this.rowcount;
      this.Limit = { 'Start': '0', 'End': this.endLimit };
      this.totalRecords = this.rowcount;
      this.defaultFilter();
      this.getColumns();
      this.getData();
  }

  getColumns() {
    let column: any = this.GridColumns;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.columnJson = this.gridService.getGridColumns(column);
      this.cols = this.gridService.getGridColumns(column);
    }
  }

  changePage(event:any) {
    this.startLimit = event.first;
    this.endLimit = this.startLimit + this.rowcount;
    this.rowcount = event.rows;

    if (this.endLimit > this.totalRecords) {
      this.endLimit = this.totalRecords;
    }
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.priviousStartLimit = this.startLimit;
    this.pageNumber = Math.round(this.startLimit / this.rowcount) + 1;
    this.getData();
  }

  getData() {
    this.previousLimit = this.Limit;
    this.dataset = [];
    this.selectedRow = new UserActionLog();
    this.isLoadingResults = true;

    this.tbldatamsg = "L o a d i n g . . . . .";
    const filterData = JSON.parse(JSON.stringify(this.defaultFilterArray));
    filterData[0].values[0] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
    filterData[0].values[1] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));

    let payload = {
      data: filterData,
      mpid: this.userService.getActiveMPID(),
      startLimit: this.Limit.Start.toString(),
      endLimit: this.Limit.End.toString()
    }

    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.GetUserActivityLog
      ), payload
    ).subscribe({
      next:(Element:any) => {
        let dataset: any = Element;
        this.dataset = dataset.Data;
        this.totalRecords = dataset.totalCount;
        this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
        if (this.dataset.length == 0) {
          this.tbldatamsg = "No data found";
        }
        this.isLoadingResults = false;
      },
      error: (err: HttpErrorResponse) => {
        this.isLoadingResults = false;
  }});
  }

  sort(event:any) {
    if(this.sortClickCounter !== 3 && (this.sortData.field === "" || this.sortData.field === event.multisortmeta[0].field)) {
      this.sortClickCounter = this.sortClickCounter + 1;
    } else {
      this.sortClickCounter = 1;
    }
    if(this.sortClickCounter !== 3) {
      let sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
      this.sortData.field = event.multisortmeta[0].field;
      this.sortData.order = sortOrder;
      this.dataset = this.sortPipe.transform(this.dataset, this.sortData.order, this.sortData.field);
    } else {
      if(this.dt.multiSortMeta != undefined && this.dt.multiSortMeta?.length > 0) {
      this.dt.multiSortMeta[0].field = '';
      this.dt.multiSortMeta[0].order = 0;
      }
    }
    
  }

  defaultFilter() {
    let date = new Date();

      this.LastExecutionDate = [];
      this.LastExecutionDate.push(date); // FromDate
      this.LastExecutionDate.push(date); // Todate

      this.defaultFilterArray = [
      {'isdefault': 'true', 'label': 'Date', 'columnname': 'Created_Date', 'filterby': 'IS', 'values': this.LastExecutionDate, 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''},
      {'isdefault': 'true', 'label': 'FirmMPID', 'columnname': 'FirmMPID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''},
      {'isdefault': 'true', 'label': 'User ID', 'columnname': 'User_ID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''}
    ]
  }

  filterApplyFilterEvent(event:any) {
    this.defaultFilterArray = [];
    this.defaultFilterArray = event;
    this.startLimit = 0;
    this.Limit.Start = 0;

    this.pageNumber = 1;
    this.dt.first = this.startLimit;
    this.getData();
  }

  openViewer(rowData:any) {
    this.selectedRow = rowData;
    if(rowData.Text2.includes('Parameters: ') && this.jsonViewerService.isJsonString(rowData.Text2.split('Parameters: ')[1])){
      this.hasJsonParameters = true;
    } else {
      this.hasJsonParameters = false;
    }
    this.activity = rowData.Text1;
    this.activityDetail = (rowData.Text2.includes('Parameters: ') && this.hasJsonParameters ? this.jsonViewerService.formatJSON(rowData.Text2.split('Parameters: ')[1]) : rowData.Text2.replaceAll(",",",\r\n"));
    this.isDataViewer = true;
  }

  closeDialogbox() {
    this.isDataViewer = false;
  }

  exportToCSV(event:any) {
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});
    let exportLimt: any;
    if (event.isExportMaxRows) {
      exportLimt = { 'Start': this.constantService.NUMBER_0, 'End': this.constantService.NUMBER_MAX_EXPORT_ROWS };
    } else {
      exportLimt = this.previousLimit;
    }

    const filterData = JSON.parse(JSON.stringify(this.defaultFilterArray));
    filterData[0].values[0] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
    filterData[0].values[1] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));

    let payload = {
      data: JSON.parse(JSON.stringify(filterData)),
      mpid: this.userService.getActiveMPID(),
      startLimit: exportLimt.Start.toString(),
      endLimit: exportLimt.End.toString()
    }
    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.GetUserActivityLog
      ),
      payload
    ).subscribe({
      next:(Element:any) => {
        let dataset: any = Element;
        dataset = dataset.Data;
      if (dataset.length > 0) {
        const options: any = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          showTitle: true,
          title: 'RSMS_User_Action_Log_' + this.userService.getyyyyMMddDateFormate(new Date()),
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          // header: ['col 1', 'col 2'] // Won't work with useKeysAsHeaders present!
          filename: this.userService.getActiveMPID() +'_RSMS_User_Action_Log_' + this.userService.getyyyyMMdd_HH_MM_SSDateFormate(new Date()),
        };
        const csvExporter = this.constantService.getExportData(dataset, event.gridColumn);
        const csv = generateCsv(options)(csvExporter);
        const blob = asBlob(options)(csv);
        saveAs(blob,options.filename);
        this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
        this.userService.logUserActivity('Export CSV', null, {
          'Text1': 'File Download Successfully | ' + (dataset.length > 0 ? dataset.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.defaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
        this.userService.logUserActivity('Export CSV', null, {
          'Text1': 'No data found',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.defaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      }
      this.emitterService.exportToCSVData.emit(true);

    },
    error: (err: HttpErrorResponse) => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while Exporting' });
      this.userService.logUserActivity('Export CSV', null, {
        'Text1': 'Error while Exporting',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(this.defaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
  }});
  }

}